( function ( $ ) {
	'use strict';
	$( '.wistia-slider .wistia-slider__main' ).each( function () {
		const autoplay = $( this ).attr( 'data-slide-autoplay' ),
			arrows = $( this ).attr( 'data-slide-arrows' ),
			slideShow = $( this ).attr( 'data-slide-show' ),
			loop = $( this ).attr( 'data-slide-loop' );

		// start the slider
		$(this).not( '.slick-initialized' ).slick( {
            autoplay: 'true' === autoplay ? true : false,
			autoplaySpeed: 3000,
			pauseOnHover: 'true' === autoplay ? true : false,
			dots: false,
			infinite: 'true' === loop ? true : false,
			arrows: 'true' === arrows ? true : false,
			slidesToShow: parseInt(slideShow),
			slidesToScroll: 1,
			touchMove: false,
			swipe: false,
			swipeToSlide: false,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				},
			]
		} );
	} );
  
} )( jQuery );